export const state = () => ({
  list: [], // Holds the list of certificates
  years: [],
  generalStatistics: {},
  generalDetail: {},
  centralDetail: {},
  centralStatistics: {}
})

export const getters = {
  getYears: (state) => state.years || [],
  generalStatistics: (state) => state.generalStatistics,
  centralStatistics: (state) => state.centralStatistics,
  generalDetail: (state) => state.generalDetail,
  centralDetail: (state) => state.centralDetail

}

export const mutations = {
  setYears(state, payload) {
    state.years = payload || []
  },
  setGeneralStat(state, stat) {
    state.generalStatistics = stat
  },
  setCentralStat(state, stat) {
    state.centralStatistics = stat
  },
  setGeneralDetail(state, stat) {
    state.generalDetail = stat
  },
  setCentralDetail(state, stat) {
    state.centralDetail = stat
  }
}

export const actions = {
  async resetStat({ commit }) {
    commit("setGeneralStat", [])
    commit("setCentralStat", [])
  },
  async fetchYears({ commit }) {
    try {
      const res = await this.$api.get("/site/common/mtms-years/")
      if (res) {
        commit("setYears", res)
      }
    } catch (err) {
      console.error("Fetch API Error:", err)
      throw err
    }
  },
  async getGeneralStat({ commit }, year) {
    try {
      const res = await this.$api.get(
        `/admin/common/general-statistics?year=${year}`
      )
      if (res) {
        commit("setGeneralStat", res)
      }
    } catch (err) {
      console.error("Fetch API Error:", err)
    }
  },
  async fetchGeneralDetail({ commit }, id) {
    try {
      const res = await this.$api.get(`/admin/common/general-statistics/${id}`)
      if (res) {
        commit("setGeneralDetail", res)
      }
    } catch (err) {
      console.error("Fetch API Error:", err)
    }
  },
  async fetchCentralDetail({ commit }, id) {
    try {
      const res = await this.$api.get(`/admin/common/central-statistics/${id}`)
      if (res) {
        commit("setCentralDetail", res)
      }
    } catch (err) {
      console.error("Fetch API Error:", err)
    }
  },
  async getCentralStat({ commit }, year) {
    try {
      const res = await this.$api.get(
        `/admin/common/central-statistics?year=${year}`
      )
      if (res) {
        commit("setCentralStat", res)
      }
    } catch (err) {
      console.error("Fetch API Error:", err)
    }
  }
}
